// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Компетенції» (Competencies, ключ `comp`, група `development`). */
export const competenciesManifest: IModuleManifest = {
  key: 'comp',
  group: 'development',
  slug: 'competencies',
  prefix: 'CPT',
  name: { en: 'Competencies', uk: 'Компетенції' },
  entities: [
    { key: 'comp', slug: 'comp', name: { en: 'Competencies', uk: 'Компетенції' }, main: true },
    { key: 'skill', slug: 'skill', name: { en: 'Skills', uk: 'Навички' }, main: false },
  ],
  loadState: () => import('./state/competenciesSlice').then((m) => m.competenciesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
